export const PERMISSIONS = {
    CREATE_WO: 'create work order',
    EDIT_WO: 'edit work order',
    DELETE_WO: 'delete work order',
    VIEW_WO: 'view work order',
    


    CREATE_REQUEST: 'create work order',
    EDIT_REQUEST: 'edit work order',
    DELETE_REQUEST: 'delete work order',
    VIEW_REQUEST :'view work order'
}